<template>
  <div class="wh-block">
    <h2 class="uk-margin-bottom">Мои занятия</h2>
    <back></back>

    <ul class="uk-grid-match uk-grid-divider" uk-grid>
      <li class="uk-width-1-3@s">
        <div>
          <add_hooky></add_hooky>
        </div>
      </li>
      <li class="uk-width-2-3@s">
        <div>
          <div v-for="item in items" :key="item.id">
            <div class="current_lesson">
              <h4>Занятия класса {{ item.title }}:</h4>
              <div v-if="item.params.lesson_desc">
                <p>{{ item.params.lesson_desc.desc }}</p>
                <a v-if="item.params.lesson_desc.zoom_link" :href="item.params.lesson_desc.zoom_link" target="_blank">{{ item.params.lesson_desc.zoom_link }}</a>
                <p v-else>Нет ссылки на zoom</p>
                <p v-if="item.params.lesson_desc.zoom_ident">Идентификатор конференции: {{ item.params.lesson_desc.zoom_ident }}</p>
                <div class="uk-margin-top">
                  <h4>Ссылка на запись прошлого урока:</h4>
                  <a :href="item.params.lesson_desc.video_link" v-if="item.params.lesson_desc.video_link">Нажмите чтобы открыть запись</a>
                  <p v-else>Нет записи прошлого урока</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import add_hooky from "./add_hooky";
import { mapGetters } from 'vuex'

export default {
  name: "lessons",
  inject: ['http'],
  components: {
    add_hooky
  },
  computed: {
    ...mapGetters({
      items: 'student/classes'
    })
  }
}
</script>